import { mapDTO } from '@twistezo/ts-dto-mapper'

import { SortInput } from 'components/Table'
import { alertsFromDTO } from 'features/alerts/api/mappers/alertFromDTO'
import { AdUnitAlert } from 'features/inventory/ad-unit/types/adUnitAlert'
import { AdUnitForProductTable, AdUnitSortBy } from '../../types'
import { AdUnitForProductTableDTO, AdUnitSortByDTO } from './types'

type From = AdUnitForProductTableDTO
type To = AdUnitForProductTable

export const adUnitForProductTableFromDTO = (from: From): To =>
  mapDTO<From, To>({
    from,
  }).transform((adUnitDTO: From): To => {
    const {
      divId,
      fieldAlerts,
      id,
      name,
      outOfPage,
      path,
      prebidStackEnabled,
      priceGeniusEnabled,
      refresherEnabled,
      unfilledRecoveryEnabled,
      updatedAt,
      viewabilityToolsEnabled,
      ybAdUnitEnabled,
    } = adUnitDTO

    return {
      alerts: alertsFromDTO<AdUnitAlert>(fieldAlerts),
      divId: divId || undefined,
      id,
      name: name || undefined,
      outOfPage,
      path,
      prebidStackEnabled,
      priceGeniusEnabled,
      refresherEnabled,
      unfilledRecoveryEnabled,
      updatedAt: new Date(updatedAt),
      viewabilityToolsEnabled: outOfPage ? false : viewabilityToolsEnabled,
      ybAdUnitEnabled: ybAdUnitEnabled ?? undefined,
    }
  })

export const sortToDTO = (sort: SortInput<AdUnitSortBy>): SortInput<AdUnitSortByDTO> => {
  const { by } = sort

  if (by === 'name') {
    return { ...sort, by: 'adUnitName' }
  } else {
    return { ...sort, by }
  }
}
